module.exports = __webpack_public_path__ + "img/type2.dfdd51e2.png";